import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Modal } from 'bootstrap';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';

@Component({
	selector: 'app-resident-select-restaurant',
	templateUrl: './resident-select-restaurant.component.html',
	styleUrls: ['./resident-select-restaurant.component.css'],
})
export class ResidentSelectRestaurantComponent {
	@Input() elements: Array<any> = [];
	@Input() restaurantList: Array<any> = [];
	@Output() closed = new EventEmitter();
	restaurant: number;

	constructor(
		protected api: Data2Service,
		private readonly infobox: InfoboxService,
	) {}

	dialogOpen() {
		new Modal(document.getElementById('addModal')).show();
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('addModal'));
		if (!modal) {
			return;
		}
		this.closed.emit();
		modal.hide();
	}

	submit() {
		const busnessCases = this.elements.map((obj) => obj.businessCaseId);
		const data = {
			restaurant: this.restaurant,
			businessCaseId: busnessCases,
		};
		this.api.post('/resident/residentRestaurant', data, (result, error) => {
			if (!error) {
				this.infobox.success('Przypisano restauracje');
				this.dialogClose();
			}
		});
	}
}
